import { Plot } from '@/components/charts';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { CarrierBreakdown } from '@/hooks/api/useAnalytics';

import { baseLayout, blueGradient } from './chart-config';

interface Props {
  data: CarrierBreakdown[];
}

export function CarrierBreakdownChart({ data }: Props) {
  const top = data.slice(0, 10);
  const labels = top.map((d) =>
    d.carrierName.length > 28 ? d.carrierName.slice(0, 25) + '...' : d.carrierName
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Top Carriers</CardTitle>
      </CardHeader>
      <CardContent>
        <Plot
          data={[
            {
              type: 'bar',
              orientation: 'h' as const,
              y: labels,
              x: top.map((d) => d.count),
              marker: {
                color: blueGradient(top.length),
                line: { width: 0 },
              },
              text: top.map((d) => `${Math.round(d.avgScore)}`),
              textposition: 'inside' as const,
              textfont: { color: '#ffffff', size: 11 },
              insidetextanchor: 'end' as const,
              hovertemplate: '%{y}<br>Count: %{x}<br>%{text}<extra></extra>',
            },
          ]}
          layout={baseLayout({
            margin: { l: 180, r: 20, t: 10, b: 40 },
            xaxis: { title: { text: 'Opportunity Count' }, gridcolor: 'rgba(148,163,184,0.15)' },
            yaxis: { autorange: 'reversed', gridcolor: 'rgba(148,163,184,0.15)', ticksuffix: '  ' },
            barcornerradius: 4,
          })}
          config={{ displayModeBar: false, responsive: true }}
          useResizeHandler
          className="h-64 w-full"
        />
      </CardContent>
    </Card>
  );
}
